// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_echarts_index_js":"8a9989f664bebf778ff2","src_app_pages_home_home_module_ts":"3d2c18bbd67cdea7efe2"}[chunkId] + ".js";
};